import { StudentLoginType } from 'types/schema-generated-types';
import { RadioGroupProps } from '@material-ui/core/RadioGroup';
import { PopperProps } from '@material-ui/core/Popper';

export interface SecretCodeSelectProps extends RadioGroupProps {
  handleClose: () => void;
  disabled?: boolean;
  secretCode?: string;
  onSecretCodeChange?: (loginType: StudentLoginType, value: string) => void;
  loginType?: StudentLoginType;
  showUnselected?: boolean;
  maxTextBoxLength?: number;
  anchorEl?: Element;
  open: boolean;
  error?: string;
  handleConfirm?: (loginType: StudentLoginType, value: string) => void;
  placement?: PopperProps['placement'];
}

export enum DisplayDirection {
  'ROW' = 'ROW',
  'COLUMN' = 'COLUMN'
}
